/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
*/

import { createGlobalStyle } from 'styled-components';

import colors from './colors';
import RevxNeue from './RevxNeue';
import Playfair from './Playfair';
import OpenSans from './OpenSans';
import GeoSlab703 from './GeoSlab703';
import GeoSlab703BT from './GeoSlab703BT';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    color: ${colors.black};
    font-size: 62.5%;
    padding: 0;
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }
  
  {/* ---- BubbleChart ---- */}
  
  .buttonFixed {
    position: fixed;
    top: 25px;
    left: 25px;
  }
  
  {/* ---- Mapbox ---- */}
  
  .mapbox-marker {
    display: block;
    border: 1px solid white;
    border-radius: 50%;
    cursor: pointer;
    padding: 0;
  }
  
  .mapbox-marker-label {
    margin-top: -25px;
    display: block;
    cursor: pointer;
    padding: 0;
  }
  
  ${OpenSans}
  ${Playfair}
  ${RevxNeue}
  ${GeoSlab703}
  ${GeoSlab703BT}
`;

export default GlobalStyle;
